import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JobTemplateSearchFormComponent } from './job-template-search-form.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@NgModule({
  declarations: [JobTemplateSearchFormComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  exports: [JobTemplateSearchFormComponent],
})
export class JobTemplateSearchFormModule {}
